export var BrandSellerEnum;
(function (BrandSellerEnum) {
    BrandSellerEnum["NeedsReview"] = "NEEDS_REVIEW";
    BrandSellerEnum["Approved"] = "APPROVED";
    BrandSellerEnum["Suspect"] = "Suspect";
    BrandSellerEnum["Locked"] = "Locked";
})(BrandSellerEnum || (BrandSellerEnum = {}));
export var BrandSellerInsert;
(function (BrandSellerInsert) {
    BrandSellerInsert["AddSeller"] = "Add Seller";
    BrandSellerInsert["CopySeller"] = "Copy Seller";
    BrandSellerInsert["SyncSellersFromBrand"] = "Sync Sellers From Brand";
    BrandSellerInsert["Create"] = "create";
})(BrandSellerInsert || (BrandSellerInsert = {}));
